import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { OperatingProfitComponentService } from './service/operating-profit-component.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
import { IncomeStatementService } from '../../income-statement/income-statement.service';

@Component({
  selector: 'app-operating-profit',
  templateUrl: './operating-profit.component.html',
  styleUrls: ['./operating-profit.component.scss']
})
export class OperatingProfitComponent implements OnInit {
  Operatingprofirorloss: FormGroup;
  isJump: any;
  NormalRoutng: boolean;
  showBubbledata: any;

  constructor(private FormBuilder: FormBuilder, private incomeStatementService: IncomeStatementService, private operatingservice: OperatingProfitComponentService, private router: Router, public commonService: CommonService, private sidenav: SideNavService) {

  }

  ngOnInit() {
    debugger;
    this.getIncomeStatementData()
    this.commonService.getNotesData();
    this.commonService.getIncomeStatementsHeaders();
    this.createformgroup();
    this.GetOperatingProfit();
    this.isJump = localStorage.getItem('isJump')
    if (localStorage.getItem("SubmitStatus") == "true")
      this.Operatingprofirorloss.disable()
    this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.Operatingprofirorloss.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.GetOperatingProfit_LY()
      }
    })
  }
  IncomeOperatingprofirorloss:any
  getIncomeStatementData() {
    debugger
    var APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.incomeStatementService.getIncomeStatement(APPeriodId).subscribe((data1) => {
      this.IncomeOperatingprofirorloss = data1;
    })
  }
  createformgroup() {
    this.Operatingprofirorloss = this.FormBuilder.group({
      OperatingProfitLossId: new FormControl(),
      OPLDepreciationExpensePropertyPlantEquipment: new FormControl(),
      OPLDepreciationExpensePropertyPlantEquipment_LY: new FormControl(),
      OPLAccumulatedDepreciationImpairmentPropertyPlantEquipment: new FormControl(),
      OPLAccumulatedDepreciationImpairmentPropertyPlantEquipment_LY: new FormControl(),
      OPLDepreciationPropertyPlantEquipmentIntangibleAssetsCriticalEstimatesJudgements: new FormControl(),
      OPLDepreciationPropertyPlantEquipmentIntangibleAssetsCriticalEstimatesJudgements_LY: new FormControl(),
      OPLAmortisationExpenseIntangibleAssets: new FormControl(),
      OPLAmortisationExpenseIntangibleAssets_LY: new FormControl(),
      OPLdisposalfixesassets: new FormControl(),
      OPLdisposalfixesassets_LY: new FormControl(),
      OPLTotalFeesToAuditors: new FormControl(),
      OPLTotalFeesToAuditors_LY: new FormControl(),
      OPLTotalOperatingLeasePayments: new FormControl(),
      OPLTotalOperatingLeasePayments_LY: new FormControl(),
      ExceptionalItemsFreeøtextComment: new FormControl(),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),

      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      MatchingData: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        debugger;
        var MatchingData = this.Operatingprofirorloss.controls['MatchingData'].value;
        this.Operatingprofirorloss.reset();
        this.Operatingprofirorloss.controls['MatchingData'].setValue({ Item1: MatchingData.Item1, Item2: MatchingData.Item2 });
        this.Operatingprofirorloss.controls['APPeriodId'].setValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      }
    })
  }

  Save() {
    debugger;
    if (this.On_NextIncomestatementValidaton()) {
      this.operatingservice.Insertoperatingdetails(this.Operatingprofirorloss.value).subscribe((data: any) => {
        this.Operatingprofirorloss.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Operating profit/(loss)", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.router.navigate(['/notes'])
        else if (nextPage == 'operatingprofit/(loss)') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.router.navigate([nextPage]);
        }
        else {
          this.router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  back() {
    this.Operatingprofirorloss.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Operating profit/(loss)", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  GetOperatingProfit() {
    this.operatingservice.getoperatingpldata(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data: any) => {
      this.Operatingprofirorloss.patchValue(data);
      this.Operatingprofirorloss.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }

  GetOperatingProfit_LY() {
    this.operatingservice.getoperatingpldata_LY(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data: any) => {
      this.showBubbledata = data;
      this.Operatingprofirorloss.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }

  On_NextIncomestatementValidaton() {
    debugger;
    if (this.commonService.showControl == true) {
      if (this.commonService.AccountTemplateId == 11) {
        if (+this.Operatingprofirorloss.controls['OPLdisposalfixesassets'].value != +this.IncomeOperatingprofirorloss.FRS101_ProfitLoss_on_disposal_of_property_plant_and_equipment) {
          Swal.fire("Andica Accounts Production", "Profit/(Loss) on disposal of fixed assets value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.StartYear + ".", 'warning');
          return false;
        }
        else if (+this.Operatingprofirorloss.controls['OPLdisposalfixesassets_LY'].value != +this.IncomeOperatingprofirorloss.FRS101_ProfitLoss_on_disposal_of_property_plant_and_equipment_LY) {
          Swal.fire("Andica Accounts Production", "Profit/(Loss) on disposal of fixed assets value for the year " + this.commonService.LastYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.LastYear + ".", 'warning');
          return false;
        }
        else
          return true
      }
      else {
        if (+this.Operatingprofirorloss.controls['OPLdisposalfixesassets'].value != +this.Operatingprofirorloss.controls['MatchingData'].value.Item1) {
          Swal.fire("Andica Accounts Production", "Profit/(Loss) on disposal of fixed assets value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.StartYear + ".", 'warning');
          return false;
        }
        else if (+this.Operatingprofirorloss.controls['OPLdisposalfixesassets_LY'].value != +this.Operatingprofirorloss.controls['MatchingData'].value.Item2) {
          Swal.fire("Andica Accounts Production", "Profit/(Loss) on disposal of fixed assets value for the year " + this.commonService.LastYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.LastYear + ".", 'warning');
          return false;
        }
        else
          return true
      }
    }
    else {
      if (this.commonService.AccountTemplateId == 11) {
        if (+this.Operatingprofirorloss.controls['OPLdisposalfixesassets'].value != +this.IncomeOperatingprofirorloss.FRS101_ProfitLoss_on_disposal_of_property_plant_and_equipment) {
          Swal.fire("Andica Accounts Production", "Profit/(Loss) on disposal of fixed assets value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.StartYear + ".", 'warning');
          return false;
        }
        else
          return true
      } else {
        if (+this.Operatingprofirorloss.controls['OPLdisposalfixesassets'].value != +this.Operatingprofirorloss.controls['MatchingData'].value.Item1) {
          Swal.fire("Andica Accounts Production", "Profit/(Loss) on disposal of fixed assets value for the year " + this.commonService.StartYear + " must tally with the amount that appears in the Income Statement account for the year " + this.commonService.StartYear + ".", 'warning');
          return false;
        }
        else
          return true
      }
      
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.Operatingprofirorloss.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.Save()) {
            return true;
          }
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }


  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}
